
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
// Mutations Object for ArtistsCatalog. Use it by importing artists/types.js and calling commit() from  artists/actions.js Action File.
export const artistsCatalogMutations = {
  [types.ArtistsCatalogData.SET.ALL] (state, payload) {
    console.log("payload.all_artists",payload)
    state.artistsCatalogData = payload;
    state.artistsList=payload.all_artists
  },

  [types.ArtistsCatalogListData.SET.ALL](state,payload){
    console.log("EEE",payload)
    if(payload.action=="INSERT"){
      state.artistsList=payload.artist;
      state.startRow=0;
    }
    else{
      state.artistsList.push(...payload.artist)
      state.startRow+=100
    }
    
  },

  [types.ArtistsCatalogListData.DELETE.SINGLE](state,payload){
    console.log("TYII",payload,state.artistsList);
    state.artistsList=state.artistsList.filter(e => e.label_artist_id != payload.label_artist_id)
    console.log("POI",state.artistsList);
  },

  ...implementSetAllNavTabDetailsMutation(types.CatalogArtistsDetails,  'artistDetails'),
}